/* template */
<template minapp="mpx" xlang="wxml"><div><notes :isShowTabIcon="(isShowTabIcon)" :notesList="(notesList)" class="notes1"><div slot="tabrefund"><ticket-table :tableValue="(tableValue1)"></ticket-table><ticket-table :tableValue="(tableValue2)"></ticket-table></div></notes></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mc04025d8"}'>
  .notes1
    border-radius 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mc04025d8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./ticket-bar.mpx.js?isComponent&outputPath=components%2Fticket-barc04025d8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./ticket-bar.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fticket-barc04025d8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mc04025d8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/ticket-barc04025d8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'explain':getComponent(require("../../../components/ticket-guide/explain.mpx?isComponent&outputPath=components%2Fexplain5641a8c0%2Findex")),'notes':getComponent(require("../../../components/ticket-guide/notes.mpx?isComponent&outputPath=components%2Fnotesfe3fd3ec%2Findex")),'ticket-table':getComponent(require("../../../components/ticket-guide/ticket-table.mpx?isComponent&outputPath=components%2Fticket-table23c58dd2%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
